export const routeUrls = {
	audienceTargeting: () => '/audience-targeting',
	dashboard: () => '/campaign-dashboard',
}
